import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const deletePlantLevelConfigSlice = createApi(`DeletePlantLevelConfigSlice`,"DELETE")

const DeletePlantLevelConfigSlice = createSlice({
  name: 'DeletePlantLevelConfigSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deletePlantLevelConfigSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePlantLevelConfigSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(deletePlantLevelConfigSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default DeletePlantLevelConfigSlice.reducer;